/**
 * Archivos PRIVADOS dentro de /uploads: CURP, foto y comprobante de la
 * inscripción (public-registrations) y comprobantes de membresía
 * (club-memberships). Se abren con liga firmada de 1 h y el servidor responde
 * `Cache-Control: private, no-store`, pero Workbox ignora esa cabecera: sin
 * esta exclusión el service worker guardaría 30 días en el teléfono una copia
 * de la CURP de un menor o de un comprobante bancario.
 */

import { T123_UPLOADS_CACHE } from "./cacheNames";

const PRIVATE_UPLOAD_PATH = /\/uploads\/+(?:public-registrations|club-memberships)(?:\/|$)/i;

export function isPrivateUploadPath(pathname: string): boolean {
  return PRIVATE_UPLOAD_PATH.test(pathname);
}

/** Uploads que SÍ se pueden guardar en el caché del SW (logos, avatares, credenciales…). */
export function isCacheableUploadPath(pathname: string): boolean {
  return pathname.includes("/uploads/") && !isPrivateUploadPath(pathname);
}

type CacheLike = Pick<Cache, "keys" | "delete">;
type CacheStorageLike = Pick<CacheStorage, "has" | "open">;

/**
 * Borra del caché de uploads las copias privadas que guardaron versiones
 * anteriores del service worker. Best effort: nunca bloquea la activación.
 */
export async function purgePrivateUploadEntries(
  cacheStorage: CacheStorageLike | undefined = typeof caches !== "undefined" ? caches : undefined,
): Promise<number> {
  if (!cacheStorage) return 0;
  try {
    if (!(await cacheStorage.has(T123_UPLOADS_CACHE))) return 0;
    const cache: CacheLike = await cacheStorage.open(T123_UPLOADS_CACHE);
    const requests = await cache.keys();
    let removed = 0;
    for (const request of requests) {
      let pathname: string;
      try {
        pathname = new URL(request.url).pathname;
      } catch {
        continue;
      }
      if (isPrivateUploadPath(pathname) && (await cache.delete(request))) removed += 1;
    }
    return removed;
  } catch {
    return 0;
  }
}
